module.exports = __webpack_public_path__ + "static/img/kia.7fefbf0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/blog/kia.jpg
// module id = hOXT
// module chunks = 0